var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button-pulldown',{staticClass:"grade-select-button",style:(_vm.setStyle),attrs:{"arrowColor":_vm.gradeMaster.color},on:{"click":_vm.clickEvent}},[_c('div',{staticClass:"text-size-medium text-weight-bold"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }